export default "/images/text-center.svg?20b47993fd390173e77b22e69ebf8a88";